var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89209 9.5C11.9632 9.5 13.6421 7.82107 13.6421 5.75C13.6421 3.67893 11.9632 2 9.89209 2C7.82102 2 6.14209 3.67893 6.14209 5.75C6.14209 7.82107 7.82102 9.5 9.89209 9.5Z",
    stroke: "#A461D8",
    strokeWidth: 1.22727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1761_11184",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3346 17C16.3346 14.0975 13.4471 11.75 9.89208 11.75C6.33708 11.75 3.44958 14.0975 3.44958 17"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1073 17C15.1073 17.6778 15.6568 18.2273 16.3346 18.2273C17.0124 18.2273 17.5619 17.6778 17.5619 17H15.1073ZM2.22231 17C2.22231 17.6778 2.77178 18.2273 3.44958 18.2273C4.12739 18.2273 4.67686 17.6778 4.67686 17H2.22231ZM16.3346 17H17.5619C17.5619 13.1961 13.8772 10.5227 9.89208 10.5227V11.75V12.9773C13.0169 12.9773 15.1073 14.9989 15.1073 17H16.3346ZM9.89208 11.75V10.5227C5.90692 10.5227 2.22231 13.1961 2.22231 17H3.44958H4.67686C4.67686 14.9989 6.76724 12.9773 9.89208 12.9773V11.75Z",
    fill: "#A461D8",
    mask: "url(#path-2-inside-1_1761_11184)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPurple);
export default __webpack_public_path__ + "static/media/user-purple.4eee0bea4d6fe03ba085e51cf3677ca0.svg";
export { ForwardRef as ReactComponent };